module.exports = __webpack_public_path__ + "img/logo-songoroo-white.435bf4fb.svg";